import { token } from '@atlaskit/tokens';
import { css } from '@emotion/react';
import React, { memo } from 'react';

import { Icon } from '@components/shared/Icon';

import { CardStatus } from '@components/learning/LearningSidebar/constants';

import { SkeletonLoader } from '@components/learning/LearningSidebar/children/SkeletonLoader';
import { dotStateMap } from '@components/learning/LearningSidebar/children/LessonCard';
import { TextTooltip } from '@components/learning/LearningSidebar/children/TextTooltip';

export const SectionsSkeletonLoader: React.FC = memo(() => (
  <div css={loaderContainerStyles}>
    {[...Array(4)].map((_, index) => (
      <div css={sectionBarStyles} key={index}>
        <Icon type={dotStateMap[CardStatus.DEFAULT]} color={token('color.icon')} />
        <div css={skeletonLoaderBarStyles}>
          <SkeletonLoader />
        </div>
      </div>
    ))}
    <div css={sectionBarStyles}>
      <Icon type={dotStateMap[CardStatus.DEFAULT]} color={token('color.icon')} />
      <TextTooltip text="Quiz" status={CardStatus.DEFAULT} isSelected={false} />
    </div>
  </div>
));

const loaderContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.100'),
  padding: token('space.100'),
});

const skeletonLoaderBarStyles = css({
  width: '100%',
  height: '20px',
  marginLeft: '10px',
});

const sectionBarStyles = css({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: '4px 0 4px 10px',
  borderRadius: '4px',
  cursor: 'pointer',

  '&:hover': {
    background: 'rgba(220, 223, 228, 0.50)',

    '&::before': {
      content: '""',
      display: 'block',
      width: '2px',
      height: '12px',
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      background: token('color.background.neutral'),
    },
  },
});
